import { getSessionToken } from "../../ui/shared/global-tools/session-storage";
import { fetchQuery } from "../shared/http-client";
import {
  type APIColumnOption,
  type TableForm,
  formatFetchAPIColumnOptionsAPI,
  formatFetchTableFormAPI,
} from "./table-appendix.formatter";

export async function fetchTableFormAPI({
  referenceId,
  tableId,
}: { referenceId: number; tableId: number }): Promise<TableForm[]> {
  const res = await fetchQuery(`references/${referenceId}/tables/${tableId}/data/form`);
  if (!res.data) return [];
  return formatFetchTableFormAPI(res.data);
}

export async function fetchAPIColumnOptionsAPI(url: string): Promise<APIColumnOption[]> {
  try {
    const token = getSessionToken();
    let headers: Record<string, string> | undefined;
    if (token) {
      headers = { Authorization: `Bearer ${token}` };
    }
    const res = await fetch(url, {
      headers,
    });
    if (res.status < 200 || res.status >= 300) {
      throw new Error("Failed to fetch API column options");
    }
    const data = await res.json();
    if (!data) return [];
    return formatFetchAPIColumnOptionsAPI(data);
  } catch (error) {
    console.error("Error fetching API column options =>", error);
    return [];
  }
}
